<form #jobForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/joborder']">Job Orders</a> > {{ joborder.job_no }}</h3>
    </div>
    <div class="form-actions">
      <ng-container *ngIf="!['done','in_production'].includes(joborder.status)">
        <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(jobForm.valid)">
          <mat-icon>save</mat-icon> Save
        </button>
        <button *ngIf="isFormDisabled && !['canceled','hold'].includes(joborder.status)" type="button" mat-stroked-button (click)="edit()">
          <mat-icon>edit</mat-icon> Edit
        </button>
        <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
          <mat-icon>add</mat-icon> Create
        </button>
        <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
      </ng-container>
      <button *ngIf="!['canceled'].includes(joborder.status)" [disabled]="!(joborder.id && isFormDisabled)" mat-stroked-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon> Action
      </button>
      <mat-menu #menu="matMenu" title="ACTION">
        <button [disabled]="!['in_production'].includes(joborder.status)" mat-menu-item (click)="confirmDialog('draft')">Save as Draft</button>
        <button [disabled]="!['draft'].includes(joborder.status)" mat-menu-item (click)="confirmDialog('schedule')">Schedule order</button>
        <button [disabled]="!['in_production'].includes(joborder.status)" mat-menu-item (click)="confirmDialog('hold')">Hold order</button>
        <button [disabled]="!['hold'].includes(joborder.status)" mat-menu-item (click)="confirmDialog('release')">Release order</button>
        <button [disabled]="joborder.is_dispatched" mat-menu-item (click)="confirmDialog('cancel')">Cancel order</button>
        <button [disabled]="!['done'].includes(joborder.status)" mat-menu-item (click)="confirmDialog('repeat')">Create Repeat order</button>
        <button [disabled]="!['done'].includes(joborder.status)" mat-menu-item (click)="confirmDialog('repair')">Create Repair order</button>
        <button mat-menu-item (click)="printJobOrder()">Print</button>
      </mat-menu>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <!-- Parent Job (conditional) -->
      <div *ngIf="joborder.parent_id" class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Parent Job No.</mat-label>
            <input [disabled]="true" type="text" matInput name="parent_id" #parent_id="ngModel" [(ngModel)]="joborder.parent.job_no">
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Job Type</mat-label>
            <mat-select [disabled]="true" [(value)]="selectedJobType" required autocomplete="off">
              <mat-option *ngFor="let jobtype of job_type" [value]="jobtype.value">{{ jobtype.viewValue }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Procedure</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedProcedure" required autocomplete="off">
              <mat-option *ngFor="let procedure of procedure" [value]="procedure.value">{{ procedure.viewValue }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <ng-container *ngIf="joborder.job_no">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Job No.</mat-label>
              <input [disabled]="true" type="text" matInput name="job_no" required [(ngModel)]="joborder.job_no">
            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="!joborder.job_no">
            <mat-form-field appearance="fill" class="w-100">
              <mat-label>Job Prefix</mat-label>
              <mat-select [(value)]="selectedJobPrefix" autocomplete="off" #doc_prefix_id [disabled]="isFormDisabled">
                <mat-option *ngFor="let prefix of allJobPrefix" [value]="prefix.id">{{ prefix.prefix }}</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Job Date</mat-label>
            <input #date="ngModel" [disabled]="isFormDisabled" matInput [min]="minDate" [(ngModel)]="joborder.job_date" name="job_date" [matDatepicker]="job_date" [min]="minDate" [max]="maxDate" required>
            <mat-datepicker-toggle matSuffix [for]="job_date">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #job_date></mat-datepicker>
            <mat-error *ngIf="date.invalid && date.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Doctor Name</mat-label>
            <mat-select #doctor_id (openedChange)="onDoctorScroll($event)" [disabled]="isFormDisabled" [(value)]="selectedDoctor" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onDoctorKey($event)" matInput name="doctort_list">
              <mat-option *ngFor="let doctor of allDoctors" [value]="doctor.id" [disabled]="doctor.active === false">
                <span *ngIf="doctor.active === false" class="text-muted">Inactive — </span>{{ doctor.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Patient Name</mat-label>
            <input #state="ngModel" type="text" matInput name="patient_name" [(ngModel)]="joborder.patient_name">
          </mat-form-field>
        </div>
      </div>

      <!-- Enclosed With Case -->
      <div class="row">
        <div class="col-sm-8 mb-3">
          <label class="field-label">Enclosed With Case</label>
          <section id="enclosed_with_case" class="example-section">
            <mat-checkbox class="example-margin" color="primary" (change)="enclosedCaseChkBox($event)" [checked]="enclosed_cases_selected?.includes(case)" *ngFor="let case of enclosed_cases" type="checkbox" value={{case}} id={{case}} name="num2">{{ case }}</mat-checkbox>
          </section>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>If Others then specify</mat-label>
            <input type="text" matInput name="enclosed_case_desc" [(ngModel)]="joborder.enclosed_case_desc">
          </mat-form-field>
        </div>
      </div>

      <!-- Implant Components -->
      <div class="row">
        <div class="col-sm-3 mb-3">
          <label class="field-label">Implant Components</label>
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Lab Analog</mat-label>
            <input type="text" placeholder="Units" matInput name="lab_analog_units" [(ngModel)]="joborder.lab_analog_units">
          </mat-form-field>
        </div>
        <div class="col-sm-3 mb-3">
          <label class="field-label">&nbsp;</label>
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Screw</mat-label>
            <input type="text" placeholder="Units" matInput name="screw_units" [(ngModel)]="joborder.screw_units">
          </mat-form-field>
        </div>
        <div class="col-sm-3 mb-3">
          <label class="field-label">&nbsp;</label>
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Impression Post</mat-label>
            <input type="text" placeholder="Units" matInput name="impression_units" [(ngModel)]="joborder.impression_units">
          </mat-form-field>
        </div>
        <div class="col-sm-3 mb-3">
          <label class="field-label">&nbsp;</label>
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Abutment</mat-label>
            <input type="text" placeholder="Units" matInput name="abutment_units" [(ngModel)]="joborder.abutment_units">
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>If Others then specify</mat-label>
            <input type="text" placeholder="Units" matInput name="job_units_desc" [(ngModel)]="joborder.job_units_desc">
          </mat-form-field>
        </div>
      </div>

      <!-- Restoration Type -->
      <div class="row">
        <div class="col-sm-8 mb-3">
          <label class="field-label">Restoration Type</label>
          <section class="example-section">
            <mat-checkbox class="example-margin" color="primary" (change)="restoTypeChkBox($event)" [checked]="restoration_type_selected?.includes(resto_type)" *ngFor="let resto_type of restoration_type" type="checkbox" value={{resto_type}} id={{resto_type}} name="num">{{ resto_type }}</mat-checkbox>
          </section>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Category</mat-label>
            <mat-select #category_id (selectionChange)="onCategoryChange($event)" (openedChange)="onCategoryScroll($event)" [disabled]="isFormDisabled" [(value)]="selectedCategory" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onCategoryKey($event)" matInput name="category_list">
              <mat-option *ngFor="let category of allCategories" [value]="category.id">{{ category.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Shade</mat-label>
            <input type="text" matInput name="shade_name" [(ngModel)]="joborder.shade_name">
          </mat-form-field>
        </div>
      </div>

      <!-- Products Tab -->
      <mat-tab-group animationDuration="0ms" class="mt-4">
        <mat-tab id="products" label="Products">
          <button [disabled]="isFormDisabled" mat-flat-button (click)="openDialog(0)" color="primary" class="m-4">
            <mat-icon>add</mat-icon> Add Product
          </button>
          <table mat-table [dataSource]="productLinesSource" #product_lines class="mat-elevation-z2">
            <ng-container matColumnDef="product_name">
              <th mat-header-cell *matHeaderCellDef>Product Name</th>
              <td mat-cell *matCellDef="let element" (click)="openDialog(element)">{{ element.product.name }}</td>
            </ng-container>
            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element; let i = index" class="cursor-pointer" (click)="deleteLine(i)"><i class="material-icons">delete</i></td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="orderLineDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: orderLineDisplayedColumns;"></tr>
          </table>
        </mat-tab>
      </mat-tab-group>

      <!-- Instructions & Delivery Date -->
      <div class="row mt-4">
        <div class="col-sm-6 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Instructions</mat-label>
            <textarea rows="4" matInput name="instructions" [(ngModel)]="joborder.instructions"></textarea>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Delivery Date</mat-label>
            <input #deliverydate="ngModel" [disabled]="isFormDisabled" matInput [(ngModel)]="joborder.delivery_date" name="delivery_date" [matDatepicker]="delivery_date" required>
            <mat-datepicker-toggle matSuffix [for]="delivery_date">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #delivery_date></mat-datepicker>
            <mat-error *ngIf="deliverydate.invalid && deliverydate.touched">Required</mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Remarks Chip + Description -->
      <div class="row">
        <div class="col-sm-6 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Select Remarks</mat-label>
            <mat-chip-grid class="matChipClasscross" #chipList aria-label="Remark selection">
              <mat-chip-row class="matChipClass" *ngFor="let remark of remarks" [removable]="removable" (removed)="remove(remark)">
                {{ remark }}
                <button matChipRemove *ngIf="removable"><mat-icon>cancel</mat-icon></button>
              </mat-chip-row>
              <input #remarkInput [formControl]="remarkCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)">
            </mat-chip-grid>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
              <mat-option *ngFor="let remark of filteredRemarks" [value]="remark">{{ remark.name }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col-sm-6 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Remarks Description</mat-label>
            <textarea id="remarks_section" rows="4" [(ngModel)]="joborder.remarks_section" matInput name="remarks_section"></textarea>
          </mat-form-field>
        </div>
      </div>

      <!-- File Upload -->
      <div class="row" *ngIf="joborder.id">
        <div class="col-sm-4 mb-3">
          <label class="field-label">Attachment</label>
          <input type="file" accept=".jpg,.png,.pdf,.jpeg" (change)="onFileSelected($event)">
        </div>
        <div class="col-sm-4 mb-3" *ngIf="joborder.filename">
          <a class="text-xs" target="_blank" href="/api/joborder/uploads/{{ joborder.filename }}">{{ joborder.filename }}</a>
        </div>
      </div>

      <!-- Comments -->
      <div class="row mt-3">
        <div class="col-sm-12">
          <label class="field-label">Comments</label>
          <ul class="commentUl">
            <li *ngFor="let comments of allComments">
              <p class="commentSpan col-sm-12"><b>{{ comments.employee?.name }}</b> {{ comments.created_at | date :'medium':'Asia/Kolkata' }}
                <br><br>{{ comments.comment_description }}</p>
            </li>
          </ul>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="job_order" [recordId]="joborder.id"></app-audit-log-viewer>
</form>
